import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.kumir = bracketIndenting({
	line: "|",
})
